/* eslint-disable */
import en from './en';

export default {
    en: {
        message: en
    }
}